import { render, staticRenderFns } from "./HeaderConfig.vue?vue&type=template&id=35759686&scoped=true"
import script from "./HeaderConfig.vue?vue&type=script&lang=js"
export * from "./HeaderConfig.vue?vue&type=script&lang=js"
import style0 from "./HeaderConfig.vue?vue&type=style&index=0&id=35759686&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35759686",
  null
  
)

export default component.exports